var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-3 mb-3 baseColor"},[_vm._v(_vm._s(_vm.$t("COPYRIGHT.TEXT"))),_c('br'),_vm._v("© "+_vm._s(_vm.getCurrentYear()))])}
var staticRenderFns = []

export { render, staticRenderFns }